import React, { FunctionComponent, useRef } from "react";
import {
  Typography,
  Button,
  Dialog,
  DialogActions,
  DialogTitle,
  DialogContent,
  Grid,
} from "@material-ui/core";
import { useStore } from "../../../store/index";
import storeLogo from "../../../assets/images/voucherLogo.bmp";
import moment from "moment";
import { useSuspendedBillStyles } from "../useSuspendedBillStyles";
import ReactToPrint from "react-to-print";
let Barcode = require("react-barcode");

type BarcodeDialogProps = {
  voucherFlag: boolean;
  billDetails: any;
  backToList: () => void;
  cancelPrint: () => void;
  voucherValidity: string;
};

export const SuspendedVoucher: FunctionComponent<BarcodeDialogProps> = ({
  voucherFlag,
  billDetails,
  backToList,
  cancelPrint,
  voucherValidity,
}) => {
  const componentRef = useRef<any>();
  const [user] = useStore("auth", "user");
  const styles = useSuspendedBillStyles();

  const calculateCheckDigit = (barcode: any) => {
    const digits = barcode.toString().split("").map(Number);
    const sum = digits
      .slice(0, 12)
      .reduce(
        (acc: any, digit: number, idx: number) =>
          acc + digit * (idx % 2 === 0 ? 1 : 3),
        0
      );

    const checkDigit = (10 - (sum % 10)) % 10;
    return checkDigit;
  };

  const barcodeNumber = billDetails.barcode_number.toString();
  const checkDigit = calculateCheckDigit(barcodeNumber);
  const fullBarcode = checkDigit + barcodeNumber;

  return (
    <div>
      <Dialog
        open={voucherFlag}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Do you want to print the following barcode?"}
        </DialogTitle>
        <DialogContent>
          <Grid
            container
            direction="row"
            justify="center"
            alignItems="center"
            spacing={2}
          >
            <Grid item xs={12} ref={componentRef}>
              <Grid
                container
                direction="row"
                justify="center"
                alignItems="center"
                spacing={2}
              >
                {" "}
                <Grid
                  item
                  xs={12}
                  style={{ textAlign: "center", paddingTop: "2em" }}
                >
                  <img
                    src={storeLogo}
                    alt="storeLogo"
                    style={{ height: "6em", width: "7em" }}
                  />
                </Grid>
                <Grid item xs={12} style={{ textAlign: "center" }}>
                  <Typography
                    gutterBottom
                    className={styles.dialogMainTitleArabic}
                  >
                    {user.companyName_AR}
                  </Typography>
                  <Typography
                    gutterBottom
                    className={styles.dialogSubTitleArabic}
                  >
                    {user.storeName_AR}
                  </Typography>
                  <Typography gutterBottom className={styles.dialogMainTitle}>
                    {user.companyName_EN}
                  </Typography>
                  <Typography gutterBottom className={styles.dialogSubTitle}>
                    {user.storeName_EN}
                  </Typography>
                </Grid>
                <Grid
                  item
                  xs={12}
                  style={{ textAlign: "center", paddingTop: "2em" }}
                >
                  <Typography gutterBottom className={styles.dialogSubTitle}>
                    Suspended Bill Voucher
                  </Typography>
                </Grid>
                <Grid item xs={12} style={{ textAlign: "center" }}>
                  {billDetails ? (
                    // <Barcode value={billDetails.barcode_number.toString()}  format="EAN13"  />
                    <Barcode value={fullBarcode} />
                  ) : (
                    ""
                  )}
                </Grid>
                <Grid item xs={12} style={{ textAlign: "center" }}>
                  <Typography gutterBottom className={styles.dialogSubTitle}>
                    Bill Date :{" "}
                    {moment(billDetails.suspended_time).format(
                      "DD-MMM-YYYY  h:mm:ss a"
                    )}
                  </Typography>
                  <Typography gutterBottom className={styles.dialogSubTitle}>
                    {billDetails.store_code}
                    {"/"}
                    {billDetails.suspended_terminal_id}
                    {"/"}
                    {billDetails.suspendend_bill_doc_number}
                  </Typography>
                  <Typography gutterBottom className={styles.dialogSubTitle}>
                    {voucherValidity}
                  </Typography>
                </Grid>
                <Grid
                  item
                  xs={12}
                  style={{ textAlign: "center", marginTop: "-1.5em" }}
                >
                  <Typography gutterBottom>
                    ---------------------------------------------------
                  </Typography>
                  <Typography gutterBottom className={styles.normalText}>
                    Printed Date :{" "}
                    {moment(new Date()).format("DD-MMM-YYYY  h:mm:ss a")}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <ReactToPrint
            trigger={() => <Button>Print</Button>}
            onAfterPrint={() => {
              backToList();
            }}
            content={() => componentRef.current}
          />
          <Button onClick={() => cancelPrint()}>Cancel</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};
